"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXArticleGroup = exports.HTMLArticleGroup = exports.HTMLArticleGroupCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const paragraphItem_1 = require("./paragraphItem");
const article_1 = require("./article");
const appdxItem_1 = require("./appdxItem");
const EmptyParagraph_1 = __importDefault(require("../common/docx/EmptyParagraph"));
const common_1 = require("../common");
exports.HTMLArticleGroupCSS = `
.main-provision {
    clear: both;
}

.article-group {
    clear: both;
}

.article-group-title {
    clear: both;
    font-weight: bold;
}

.suppl-provision {
    clear: both;
}

.suppl-provision-label {
    clear: both;
    font-weight: bold;
}
`;
exports.HTMLArticleGroup = (0, html_1.wrapHTMLComponent)("HTMLArticleGroup", ((props) => {
    const { el, htmlOptions, indent } = props;
    const blocks = [];
    const ArticleGroupTitle = el.children.find(std.isArticleGroupTitle);
    const SupplProvisionLabel = el.children.find(std.isSupplProvisionLabel);
    if (ArticleGroupTitle) {
        const titleIndent = std.articleGroupTitleTags.indexOf(ArticleGroupTitle.tag) + 2;
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement("div", { className: "empty" },
                react_1.default.createElement("br", null)));
        blocks.push((react_1.default.createElement("div", { className: `article-group-title indent-${indent + titleIndent}`, ...(0, html_1.elProps)(ArticleGroupTitle, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: ArticleGroupTitle.children, htmlOptions }))));
    }
    if (SupplProvisionLabel && std.isSupplProvision(el)) {
        const Extract = el.attr.Extract === "true" ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(html_1.HTMLMarginSpan, null),
            "\u6284") : "";
        const AmendLawNum = el.attr.AmendLawNum ? `（${el.attr.AmendLawNum}）` : "";
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement("div", { className: "empty" },
                react_1.default.createElement("br", null)));
        blocks.push((react_1.default.createElement("div", { className: `suppl-provision-label indent-${indent + 3}`, ...(0, html_1.elProps)(SupplProvisionLabel, htmlOptions) },
            react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: SupplProvisionLabel.children, htmlOptions }),
            AmendLawNum,
            Extract)));
    }
    const bodyBlocks = [];
    for (const child of el.children) {
        if (std.isArticleGroupTitle(child)
            || std.isSupplProvisionLabel(child)) {
            continue;
        }
        else if (std.isArticle(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(article_1.HTMLArticle, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isParagraph(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isArticleGroup(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(exports.HTMLArticleGroup, { el: child, indent: indent, htmlOptions }));
        }
        else if (std.isSupplProvisionAppdxItem(child)) {
            if (bodyBlocks.length > 0)
                bodyBlocks.push(react_1.default.createElement("div", { className: "empty" },
                    react_1.default.createElement("br", null)));
            bodyBlocks.push(react_1.default.createElement(appdxItem_1.HTMLAppdxItem, { el: child, indent: indent, htmlOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    const classNameBase = (std.isMainProvision(el)
        ? "main-provision"
        : std.isSupplProvision(el)
            ? "suppl-provision"
            : "article-group");
    if (bodyBlocks.length > 0) {
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement("div", { className: "empty" },
                react_1.default.createElement("br", null)));
        blocks.push((react_1.default.createElement("div", { className: `${classNameBase}-body` }, (0, common_1.withKey)(bodyBlocks))));
    }
    return (react_1.default.createElement("div", { className: classNameBase, ...(0, html_1.elProps)(el, htmlOptions) }, (0, common_1.withKey)(blocks)));
}));
exports.DOCXArticleGroup = (0, component_1.wrapDOCXComponent)("DOCXArticleGroup", ((props) => {
    const { el, docxOptions, indent } = props;
    const blocks = [];
    const ArticleGroupTitle = el.children.find(std.isArticleGroupTitle);
    const SupplProvisionLabel = el.children.find(std.isSupplProvisionLabel);
    if (ArticleGroupTitle) {
        const titleIndent = std.articleGroupTitleTags.indexOf(ArticleGroupTitle.tag) + 2;
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `IndentHanging${indent + titleIndent}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: ArticleGroupTitle.children, emphasis: true, docxOptions }))));
    }
    if (SupplProvisionLabel && std.isSupplProvision(el)) {
        const Extract = el.attr.Extract === "true" ? react_1.default.createElement(react_1.default.Fragment, null,
            "$",
            component_1.DOCXMargin,
            "\u6284") : "";
        const AmendLawNum = el.attr.AmendLawNum ? `（${el.attr.AmendLawNum}）` : "";
        if (blocks.length > 0)
            blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
        blocks.push((react_1.default.createElement(tags_1.w.p, null,
            react_1.default.createElement(tags_1.w.pPr, null,
                react_1.default.createElement(tags_1.w.pStyle, { "w:val": `IndentHanging${indent + 3}` })),
            react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: SupplProvisionLabel.children, emphasis: true, docxOptions }),
            AmendLawNum,
            Extract)));
    }
    for (const child of el.children) {
        if (std.isArticleGroupTitle(child)
            || std.isSupplProvisionLabel(child)) {
            continue;
        }
        else if (std.isArticle(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(article_1.DOCXArticle, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isParagraph(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isArticleGroup(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(exports.DOCXArticleGroup, { el: child, indent: indent, docxOptions }));
        }
        else if (std.isSupplProvisionAppdxItem(child)) {
            if (blocks.length > 0)
                blocks.push(react_1.default.createElement(EmptyParagraph_1.default, null));
            blocks.push(react_1.default.createElement(appdxItem_1.DOCXAppdxItem, { el: child, indent: indent, docxOptions }));
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=articleGroup.js.map